<template>
  <article class="results-list__item" data-id="results-list-item">
    <div class="results-list__item-img" v-if="item.image">
      <picture>
        <source srcset="" sizes="100vw">
        <img :src="image" :alt="item.image_alt" title="">
      </picture>
    </div>
    <div class="results-list__content">
      <span class="results-list__tophat u-secondary-dark" v-if="item.event_type_friendly && item.event_type_friendly.length">{{ eventTypeFriendly(item) }}</span>
      <a :href="href" v-if="title">
        <h3 class="results-list__title u-primary-very-dark u-hover-tertiary-dark u-medium-title u-sans-serif u-sans-serif-title u-type-28 u-type-until-bp-small-24">
          {{ title | strip }}
        </h3>
      </a>

      <div class="results-list__event-meta">
        <div class="results-list__time" v-if="item.start_date_and_time_1 || item.start_date_date_only_1">
          {{ dateTime }}
        </div>
        <div v-if="!isEyeOnEquityEvent(item)" class="results-list__locations">
          <!-- @TODO -->
          <div class="results-list__locations-1" v-if="item.location_1" v-html="item.location_1"></div>
          <div class="results-list__locations-2 u-before-bg-primary-medium-dark" v-if="item.location_2" v-html="item.location_2"></div>
        </div>
      </div>

      <div class="results-list__summary u-sans-serif u-type-16" v-if="summary">
        {{ summary | strip }}
      </div>
    </div>
  </article>
</template>

<script>
import moment from 'moment'
import calendar from '@/mixins/calendar'

export default {
    name: 'ResultsListEventItem',
    mixins: [calendar],
    props: ['item'],
    data() {
      return {
        timeZone: 'US/Eastern',
        timeZones: {
          'Alaska': 'US/Alaska',
          'Central': 'US/Central',
          'Eastern': 'US/Eastern',
          'Hawaii-Aleutian': 'US/Hawaii',
          'Mountain': 'US/Mountain',
          'Mountain (AZ)': 'US/Arizona',
          'Pacific': 'US/Pacific'
        }
      }
    },
    computed: {
      href () {
        if(this.item.path) {
          return this.item.path
        }
        else {
          return this.item.url
        }
      },
      title () {
        return this.item.title;
      },
      summary () {
        if (this.isEyeOnEquityEvent(this.item)) {
          return this.item.summary
        }

        let end_date_time
        let current_date_time
        if(this.item.start_date_and_time_1 === undefined) {
          end_date_time = new Date(moment(this.item.event_conclusion_date_and_time).add(1, 'days').format());
          current_date_time = new Date();
        } else {
          end_date_time = new Date(this.item.event_conclusion_date_and_time);
          current_date_time = new Date();
        }
        return end_date_time > current_date_time ? this.item.summary : "This event has concluded.";
      },
      image () {
        return this.item.image
      },
      dateTime() {
        // Thursday, June 8, 2022, 3:00 - 4:30 PM EDT + 1 more event
        let date_time = ''
        let time_zone = this.item.time_zone_for_display ? this.timeZones[this.item.time_zone_for_display] : this.timeZone
        if (this.hasTime()) {
          // Deal with Eye on Equity events first. They should never have a time
          // but we'll handle it anyway.
          if (this.isEyeOnEquityEvent(this.item)) {
            const eoeDateTime = this.hasEndDate()
              ? this.item.end_date_and_time_1
              : this.item.start_date_and_time_1

            // Return without the time or timezone.
            return moment(String(eoeDateTime.slice(0, 10))).format('LL');
          }

          if(this.hasEndDate()) {
            const isSameDay = this.isSameDay(this.item.start_date_and_time_1, this.item.end_date_and_time_1)
            if(isSameDay) {
              date_time += moment(String(this.item.start_date_and_time_1)).tz(time_zone).format('LLLL')
                  + ' - ' + moment(String(this.item.end_date_and_time_1)).tz(time_zone).format('LT')
                  + ' ' + moment.tz(time_zone).zoneAbbr();
            } else {
              date_time += moment(String(this.item.start_date_and_time_1)).tz(time_zone).format('LLLL')
                  + ' - ' + moment(String(this.item.end_date_and_time_1)).tz(time_zone).format('LLLL')
                  + ' ' + moment.tz(time_zone).zoneAbbr();
            }
          } else {
            date_time += moment(String(this.item.start_date_and_time_1)).tz(time_zone).format('LLLL') + ' ' + moment.tz(time_zone).zoneAbbr();
          }
        } else {
          date_time += moment(String(this.item.start_date_date_only_1.slice(0, 10))).format('LL')
          if (this.hasEndDate()) {
            const isSameDay = this.isSameDay(
                this.item.start_date_date_only_1,
                this.item.end_date_and_time_1
            );
            if (!isSameDay) {
              date_time += ' - ' + moment(
                  String(this.item.end_date_and_time_1.slice(0, 10))
              ).format('LL');
            }
          }
        }

        // If an event has more than one Date and Time paragraph,
        // we display some "+x more" to indicated that there are multiple days and sessions
        // date_time += this.item.event_count > 1 ? (' + ' + (this.item.event_count-1) + ' more event'
        //     + (this.item.event_count > 2 ? 's' : '')) : '';

        return date_time;
      }
    },
    methods: {
      isSameDay(start, end) {
        return moment(String(start)).format('L') === moment(String(end)).format('L')
      },
      hasTime() {
        return this.item.start_date_and_time_1 !== undefined
      },
      hasEndDate() {
        return this.item.end_date_and_time_1 !== undefined
      }
    }
  }
</script>
